import type { ScreenshotRejectionReason } from '@pypestream/utils';
import type { TranslationKeys } from '@pypestream/translations';

/**
 * What stays in the app after the form moved to `@pypestream/ui-patterns`:
 * this app's translation keys.
 *
 * The form itself takes its strings as `labels` (the shape `AppErrorBoundary`
 * already uses), because each app initialises i18next with ONE scope and loads
 * only that scope's namespaces — a key hardcoded in the shared package would
 * render as a raw key in whichever app does not own the scope.
 */

/** Says why a file was turned away, in the user's language. */
export const screenshotRejectionKey = (
  reason: ScreenshotRejectionReason
): TranslationKeys => {
  const keys: Record<ScreenshotRejectionReason, string> = {
    'not-an-image': 'pro-studio/navigation:report_bug_modal.rejected.not_image',
    'too-large': 'pro-studio/navigation:report_bug_modal.rejected.too_large',
    'too-many': 'pro-studio/navigation:report_bug_modal.rejected.too_many',
    'over-total-size':
      'pro-studio/navigation:report_bug_modal.rejected.over_total_size',
  };

  return keys[reason] as TranslationKeys;
};
